module.exports = __webpack_public_path__ + "media/images/og-tJ-964444ccce99338798ee56b56ea8f002.png";